import angular from 'angular'

// Make sure trix is loaded, since the page loads the apex-trix-editor
import "trix"
import "trix/dist/trix.css"

import { EditLegalNoticeComponent } from './edit-legal-notice.component';
import { LegalNoticeListComponent } from './legal-notice-list.component';
import { AcknowledgeLegalNoticeComponent } from './acknowledge-legal-notice.component';

import { SharedModule } from '../shared/shared.module'

export const LegalNoticeModule = angular
    .module("apex.mainApp.legalNotices", [
        SharedModule
    ])
    .component("apexEditLegalNotice", EditLegalNoticeComponent)
    .component("apexLegalNoticeList", LegalNoticeListComponent)
    .component("apexAcknowledgeLegalNotice", AcknowledgeLegalNoticeComponent)
    .name
